import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 43"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "i-1314830371__a",
      fill: "#fff"
    }, [
      _createElementVNode("rect", {
        width: "32",
        height: "34",
        y: "8.656",
        rx: "1"
      })
    ], -1),
    _createElementVNode("rect", {
      width: "32",
      height: "34",
      y: "8.656",
      stroke: "#121212",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      mask: "url(#i-1314830371__a)",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#121212",
      "stroke-width": "2",
      d: "M23.772 8.656v1h1v-1C24.772 4.364 21.065 1 16.641 1c-4.425 0-8.132 3.364-8.132 7.656v1h1v-1 1H23.773v-1Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "cart"}) } }